import React, { useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';

import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import { CSSTransition } from 'react-transition-group';

import { GET_PAYMENT } from '../../shared';
import { BackButton, PageTitle } from '../common';
import ErrorPlaceholder from '../../features/errorPlaceholder';

import PaymentStatusBlock from './PaymentStatusBlock';
import { StyledVerticalContent } from './PaymentDetails.styled';

// sort the array based on the date
const sortFilterArray = (arr) => {
  if (!Array.isArray(arr)) return [];

  return arr.sort((a, b) => {
    return new Date(b.billingMonth) - new Date(a.billingMonth);
  });
};

export default function PaymentDetails() {
  const getPayments = useQuery(GET_PAYMENT);
  const paymentsData = getPayments?.data?.payments;
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    if (paymentsData) {
      const failedAndBlockedPayments = paymentsData.filter((item) => item.status === 'failed');
      const paidAndOtherPayments = paymentsData.filter((item) => item.status !== 'failed');
      const sortedFailedAndBlockedPayments = sortFilterArray(failedAndBlockedPayments);
      const sortedPaidAndOtherPayments = sortFilterArray(paidAndOtherPayments);
      const finalPaymentsArray = [...sortedFailedAndBlockedPayments, ...sortedPaidAndOtherPayments];

      setPayments(finalPaymentsArray);
    }
  }, [paymentsData]);

  if (getPayments?.error)
    return (
      <>
        <BackButton to="/" />
        <ErrorPlaceholder />;
      </>
    );

  if (getPayments?.data?.payments) {
    return (
      <CSSTransition in={payments?.length >= 0} timeout={400} classNames="slow-fade" unmountOnExit>
        <Container>
          <BackButton to="/" />

          <PageTitle>
            <Typography variant="h1">
              <FormattedMessage id="payment.page.main.heading" />
            </Typography>
          </PageTitle>

          <StyledVerticalContent>
            <Typography variant="p">
              <FormattedMessage id="payment.page.main.sub.heading" />
            </Typography>

            {payments &&
              payments.length > 0 &&
              payments.map((item) => <PaymentStatusBlock key={item?.billingMonth} data={item} />)}

            {payments && payments.length === 0 && (
              <Typography variant="p">
                <FormattedMessage id="payment.page.no.payments" />
              </Typography>
            )}
          </StyledVerticalContent>
        </Container>
      </CSSTransition>
    );
  }

  return null;
}
